import { Asset } from '@/api/generatedApi';
import { AssetPageObjectModel } from '@/poms/assetPageObjectModel';
import { useTenants } from '@/services/tenants/useTenants';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { PiCubeBold } from 'react-icons/pi';
import { Link } from 'react-router-dom';

export const ViewAssetButton = ({ asset, size = 'small' }: { asset: Asset; size?: IconButtonProps['size'] }) => {
  const { getPath } = useTenants();

  return (
    <Tooltip title='View Asset'>
      <Link to={getPath(`asset/${asset.id}`)} data-testid={AssetPageObjectModel.ViewAssetButton}>
        <IconButton size={size}>
          <PiCubeBold style={{ width: '20px', height: '20px', margin: '2px' }} />
        </IconButton>
      </Link>
    </Tooltip>
  );
};
